(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VoucherSaleConfirmationSearch', VoucherSaleConfirmationSearch);

    VoucherSaleConfirmationSearch.$inject = ['$resource'];

    function VoucherSaleConfirmationSearch($resource) {
        var resourceUrl =  'api/_search/voucher-sale-confirmations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
